import React, { Fragment } from "react";
import {
  Breadcrumb,
  BreadcrumbGroup,
  Layout,
  TemplateFullGutter,
  LayoutWrapper
} from "@common/AggregationComponent";
import { TemplateFullGutterProps } from "uq-global-ec-uikit/components/dist/react/esm/src/components";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CombinedReducersType } from "@type/index";
import { getEcRenewalCompatibility } from "@util/common";

const NavigationPathForNewUI3 = () => {
  const { t } = useTranslation();
  const config = useSelector((store: CombinedReducersType) => store.app);
  const BASE_PATH_NAME = `/${config.region}/${config.language}`;
  return !config.isApp ? (
    <LayoutWrapper element="section" className="fr-ec-breadcrump-wrapper">
      <Layout gutter={{ sm: false, md: false, lg: true }} element="div">
        <BreadcrumbGroup className="fr-ec-mb-spacing-05">
          <Breadcrumb element="a" href={`${BASE_PATH_NAME}/`}>
            {t("text_breadcrumbs_top")}
          </Breadcrumb>
          <Breadcrumb element="a" href={`${BASE_PATH_NAME}/search`}>
            {t("text_productsearch")}
          </Breadcrumb>
          <Breadcrumb element="a" href={`${BASE_PATH_NAME}/image-search`}>
            {t("text_image_search")}
          </Breadcrumb>
        </BreadcrumbGroup>
      </Layout>
    </LayoutWrapper>
  ) : (
    <></>
  );
};

const NavigationPath = () => {
  const { t } = useTranslation();
  const config = useSelector((store: CombinedReducersType) => store.app);
  const BASE_PATH_NAME = `/${config.region}/${config.language}`;
  return !config.isApp ? (
    <Layout
      colSpan={{
        lg: 12,
        md: 12,
        sm: 4
      }}
      element="div"
      className="fr-ec-mb-spacing-01"
    >
      <BreadcrumbGroup>
        <Breadcrumb element="a" href={`${BASE_PATH_NAME}/`}>
          {t("text_breadcrumbs_top")}
        </Breadcrumb>
        <Breadcrumb element="a" href={`${BASE_PATH_NAME}/search`}>
          {t("text_productsearch")}
        </Breadcrumb>
        <Breadcrumb element="a" href={`${BASE_PATH_NAME}/image-search`}>
          {t("text_image_search")}
        </Breadcrumb>
      </BreadcrumbGroup>
    </Layout>
  ) : (
    <></>
  );
};

const NavWhiteDiv = () => (
  <Layout
    colSpan={{
      lg: 12,
      md: 12,
      sm: 4
    }}
    element="div"
    className="fr-ec-mb-spacing-01"
  />
);

const withBreadcrumb =
  (Component: any, props?: Omit<TemplateFullGutterProps, "mainContent">) =>
  () =>
    (
      <>
        <TemplateFullGutter
          {...props}
          mainContent={<Component />}
          navigationPath={
            getEcRenewalCompatibility() ? <NavWhiteDiv /> : <NavigationPath />
          }
        />
        {getEcRenewalCompatibility() && <NavigationPathForNewUI3 />}
      </>
    );
export default withBreadcrumb;
